// AdminStaff permissions (not clinic permissions)
export const ADMIN_PERMISSIONS = [
  { group: "Dashboard", items: ["admin-dashboard:read"] },
  { group: "Klinikler", items: ["admin-clinics:read", "admin-clinics:create", "admin-clinics:update", "admin-clinics:delete", "admin-clinics:view-roles", "admin-clinics:create-role", "admin-clinics:update-role", "admin-clinics:delete-role", "admin-clinics:view-info", "admin-clinics:update-name", "admin-clinics:update-email", "admin-clinics:update-contact", "admin-clinics:update-tax", "admin-clinics:update-status", "admin-clinics:update-work-type", "admin-clinics:update-working-hours", "admin-clinics:update-theme", "admin-clinics:update-logo", "admin-clinics:view-tokens", "admin-clinics:load-tokens", "admin-clinics:refund-tokens", "admin-clinics:view-token-analytics", "admin-clinics:update-token-pricing", "admin-clinics:view-appearance", "admin-clinics:view-patients", "admin-clinics:whatsapp", "admin-patients:view-detail"] },
  { group: "Cihazlar", items: ["admin-devices:read", "admin-devices:manage"] },
  { group: "Kullanıcılar", items: ["users:read", "users:create", "users:update", "users:delete", "users:manageStatus"] },
  { group: "Rol Yönetimi", items: ["admin-roles:read", "admin-roles:create", "admin-roles:update", "admin-roles:delete"] },
  { group: "Sistem Değişkenleri", items: ["admin-system-variables:read", "admin-system-variables:manage"] },
  { group: "Denetim", items: ["admin-audit:read"] },
  { group: "Raporlar", items: ["admin-reports:read"] },
];

// Tam izin anahtarı → Türkçe etiket eşlemesi
const PERM_KEY_LABELS = {
  // Dashboard
  "admin-dashboard:read": "Dashboard görüntüleme",

  // Klinikler
  "admin-clinics:read": "Klinik listesi görüntüleme",
  "admin-clinics:create": "Klinik oluşturma",
  "admin-clinics:update": "Klinik güncelleme",
  "admin-clinics:delete": "Klinik silme",
  "admin-clinics:view-roles": "Rol şablonları görüntüleme",
  "admin-clinics:create-role": "Personel şablonu oluşturma",
  "admin-clinics:update-role": "Personel şablonu güncelleme",
  "admin-clinics:delete-role": "Personel şablonu silme",
  "admin-clinics:view-info": "Klinik bilgileri görüntüleme",
  "admin-clinics:update-name": "Klinik adı güncelleme",
  "admin-clinics:update-email": "Klinik e-posta güncelleme",
  "admin-clinics:update-contact": "İletişim bilgileri güncelleme",
  "admin-clinics:update-tax": "Vergi bilgileri güncelleme",
  "admin-clinics:update-status": "Klinik durumu güncelleme",
  "admin-clinics:update-work-type": "Profil ve modül güncelleme",
  "admin-clinics:update-working-hours": "Çalışma saatleri güncelleme",
  "admin-clinics:update-theme": "Tema rengi güncelleme",
  "admin-clinics:update-logo": "Logo güncelleme",
  "admin-clinics:view-tokens": "Token bakiyesi görüntüleme",
  "admin-clinics:load-tokens": "Token yükleme",
  "admin-clinics:refund-tokens": "Token iadesi",
  "admin-clinics:view-token-analytics": "Token analitiklerini görüntüleme",
  "admin-clinics:update-token-pricing": "Token tüketim şablonu güncelleme",
  "admin-clinics:view-appearance": "Görünüm sekmesini görüntüleme",
  "admin-clinics:view-patients": "Klinik hastalarını görüntüleme",
  "admin-clinics:whatsapp": "Klinik WhatsApp bağlantısını askıya alma ve şablonlarını yenileme",
  "admin-patients:view-detail": "Hasta detay sayfasını görüntüleme",

  // Cihazlar
  "admin-devices:read": "Cihaz listesi görüntüleme",
  "admin-devices:manage": "Cihaz yönetimi (oluşturma/atama/silme)",

  // Kullanıcılar
  "users:read": "Kullanıcı listesi görüntüleme",
  "users:create": "Kullanıcı oluşturma",
  "users:update": "Kullanıcı güncelleme",
  "users:delete": "Kullanıcı silme",
  "users:manageStatus": "Kullanıcı durumu yönetme",

  // Rol Yönetimi
  "admin-roles:read": "Personel şablonu listesi görüntüleme",
  "admin-roles:create": "Personel şablonu oluşturma",
  "admin-roles:update": "Personel şablonu güncelleme",
  "admin-roles:delete": "Personel şablonu silme",

  // Sistem Değişkenleri
  "admin-system-variables:read": "Sistem değişkenlerini görüntüleme",
  "admin-system-variables:manage": "Sistem değişkenlerini yönetme",

  // Denetim
  "admin-audit:read": "Denetim kayıtlarını görüntüleme",

  // Raporlar
  "admin-reports:read": "Raporları görüntüleme",
};

// Aksiyon-fallback haritası (key map'te yoksa)
const PERM_ACTION_LABELS = {
  "read": "Görüntüleme",
  "create": "Oluşturma",
  "update": "Güncelleme",
  "delete": "Silme",
  "manage": "Yönetim",
  "manageStatus": "Durum Yönetimi",
  "view-staff": "Personel görüntüleme",
  "create-staff": "Personel oluşturma",
  "delete-staff": "Personel silme",
  "view-roles": "Rol görüntüleme",
  "create-role": "Rol oluşturma",
  "update-role": "Rol güncelleme",
  "delete-role": "Rol silme",
  "view-info": "Bilgi görüntüleme",
  "update-name": "Ad güncelleme",
  "update-email": "E-posta güncelleme",
  "update-contact": "İletişim güncelleme",
  "update-tax": "Vergi güncelleme",
  "update-status": "Durum güncelleme",
  "update-work-type": "Profil ve modül güncelleme",
  "update-working-hours": "Çalışma saatleri güncelleme",
  "update-theme": "Tema güncelleme",
  "update-logo": "Logo güncelleme",
  "view-tokens": "Token görüntüleme",
  "load-tokens": "Token yükleme",
  "refund-tokens": "Token iadesi",
  "view-token-analytics": "Token analitikleri",
  "update-token-pricing": "Token fiyatlandırma",
  "view-appearance": "Görünüm görüntüleme",
  "whatsapp": "WhatsApp bağlantısını askıya alma",
};

export function getPermLabel(perm) {
  if (PERM_KEY_LABELS[perm]) return PERM_KEY_LABELS[perm];
  const parts = String(perm || "").split(":");
  const action = parts[parts.length - 1];
  return PERM_ACTION_LABELS[action] || action;
}

// AdminStaff rol şablonları için server API yok — localStorage ile kalıcılık.
// CreateAdminStaffDrawer ve UsersToolbar da AYNI anahtarı okur.
export const ROLE_TPL_STORAGE_KEY = "pupill:adminRoleTemplates";

export function loadStoredTemplates() {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(ROLE_TPL_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) ? parsed : [];
  } catch (_e) { return []; }
}

export function saveStoredTemplates(arr) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(ROLE_TPL_STORAGE_KEY, JSON.stringify(arr || []));
  } catch (_e) { /* yut */ }
}
